import type { Theme, WithStyles } from "@envestnet/envreact-component-library";
import { createStyles } from "@envestnet/envreact-component-library";

const styles = (theme: Theme) =>
  createStyles({
    container: {
      marginTop: "auto",
      paddingTop: "24px",
      paddingBottom: "40px",
    },
    footerDiv: {
      display: "flex",
    },
    links: {
      color: theme.colors.textSubtle,
      marginLeft: "24px",
      height: 0,
      ...theme.fonts.caption,
      textTransform: "capitalize",
      letterSpacing: "2px",
      "&:focus": {
        color: `${theme.colors.action} !important`,
        textDecoration: "underline",
        outline: "none",
      },
      "&:hover": {
        color: `${theme.colors.action} !important`,
        textDecoration: "none",
      },
    },
    termsTitleClass: {
      fontFamily: "Red Hat Display, sans-serif",
    },
    termsStyle: {
      ...theme.fonts.p2,
      fontFamily: "Red Hat Text, sans-serif",
      color: theme.colors.textDefault,
      overflow: "auto",
      "&::-webkit-scrollbar": {
        width: "6px",
        height: "6px",
      },
      "&::-webkit-scrollbar-track": {
        backgroundColor: theme.colors.background,
        borderRadius: "4px",
      },
      "&::-webkit-scrollbar-thumb": {
        backgroundColor: theme.colors.textSubtle,
        borderRadius: "4px",
      },
    },
    termsCheckboxStyle: {
      "& button": {
        borderRadius: "0",
      },
    },
    TnCContainer: {
      height: 504,
      width: "100%",
      overflow: "scroll",
    },
    linkButtonStyle: {
      height: 0,
      marginBottom: 40,
      fontSize: 14,
      fontFamily: "Red Hat Text, sans-serif",
      fontStyle: "normal",
      fontWeight: 400,
      lineHeight: "normal",
      padding: "0 4px",
    },
    acceptUpdatedTnCCheckbox: {
      marginTop: "24px",
      display: "flex",
      flexDirection: "row",
    },
    acceptUpdatedTnCCheckboxLabel: {
      marginLeft: "8px",
      fontFamily: "Red Hat Text, sans-serif",
    },
  });

export type Styles = WithStyles<typeof styles>;
export default styles;
